import React, { useState, useEffect } from 'react';

// --- Стили (с адаптивом для мобильных) ---
const styles = {
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '20px',
    fontFamily: 'Arial, sans-serif'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '30px',
    borderBottom: '2px solid #007bff',
    paddingBottom: '10px',
    flexWrap: 'wrap'
  },
  tabButton: (isActive) => ({
    background: isActive ? '#007bff' : '#f1f1f1',
    color: isActive ? 'white' : '#333',
    border: 'none',
    padding: '10px 20px',
    fontSize: '18px',
    cursor: 'pointer',
    borderRadius: '8px',
    transition: '0.3s'
  }),
  stats: {
    display: 'flex',
    gap: '20px',
    background: '#e9ecef',
    padding: '10px 20px',
    borderRadius: '8px',
    flexWrap: 'wrap',
    fontSize: '14px'
  },
  form: {
    background: '#f9f9f9',
    padding: '20px',
    borderRadius: '12px',
    marginBottom: '30px',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px'
  },
  formRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
    gap: '15px'
  },
  input: {
    padding: '12px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    fontSize: '16px',
    fontFamily: 'Arial, sans-serif'
  },
  button: {
    background: '#28a745',
    color: 'white',
    border: 'none',
    padding: '12px 20px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '16px'
  },
  dangerButton: {
    background: '#dc3545',
    color: 'white',
    border: 'none',
    padding: '8px 12px',
    borderRadius: '4px',
    cursor: 'pointer',
    marginRight: '5px',
    fontSize: '14px'
  },
  editButton: {
    background: '#ffc107',
    color: '#333',
    border: 'none',
    padding: '8px 12px',
    borderRadius: '4px',
    cursor: 'pointer',
    marginRight: '5px',
    fontSize: '14px'
  },
  addButton: {
    background: '#17a2b8',
    color: 'white',
    border: 'none',
    padding: '8px 12px',
    borderRadius: '4px',
    cursor: 'pointer',
    marginTop: '5px',
    fontSize: '14px'
  },
  thTd: {
    border: '1px solid #ddd',
    padding: '8px',
    textAlign: 'left'
  },
  workItem: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
    marginBottom: '10px',
    flexWrap: 'wrap'
  },
  centerButton: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px'
  },
  currentSum: {
    background: '#d1ecf1',
    padding: '10px 15px',
    borderRadius: '8px',
    marginBottom: '15px',
    textAlign: 'center',
    fontSize: '18px',
    fontWeight: 'bold'
  },
  syncStatus: {
    fontSize: '12px',
    color: '#28a745',
    marginLeft: '10px'
  },
  // Стили для страницы рентабельности
  profitPanel: {
    display: 'flex',
    gap: '20px',
    marginBottom: '30px',
    flexWrap: 'wrap'
  },
  userCard: (isPositive) => ({
    flex: 1,
    background: '#f8f9fa',
    borderRadius: '12px',
    padding: '20px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    borderLeft: `4px solid ${isPositive ? '#28a745' : '#dc3545'}`
  }),
  profitRow: {
    display: 'flex',
    gap: '10px',
    marginTop: '15px'
  },
  profitMain: {
    flex: '0 0 50%',
    background: '#e9ecef',
    padding: '15px',
    borderRadius: '8px',
    textAlign: 'center'
  },
  profitSide: {
    flex: '0 0 25%',
    background: '#e9ecef',
    padding: '15px',
    borderRadius: '8px',
    textAlign: 'center'
  },
  profitDebt: (debtAmount, isViewer) => {
    let bgColor = '#e9ecef';
    if (debtAmount > 0) bgColor = '#dc3545';
    if (debtAmount < 0) bgColor = '#28a745';
    if (debtAmount === 0 && !isViewer) return { display: 'none' };
    return {
      flex: debtAmount === 0 ? '0 0 10%' : '0 0 25%',
      background: bgColor,
      padding: '15px',
      borderRadius: '8px',
      textAlign: 'center',
      color: debtAmount !== 0 ? 'white' : '#333'
    };
  },
  historyWindow: {
    background: '#fff',
    border: '1px solid #dee2e6',
    borderRadius: '12px',
    height: '300px',
    overflowY: 'auto',
    padding: '15px',
    marginBottom: '20px'
  },
  historyItem: {
    padding: '10px',
    borderBottom: '1px solid #eee',
    fontSize: '14px'
  },
  selectInput: {
    padding: '12px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    fontSize: '16px',
    backgroundColor: 'white'
  },
  squareButton: {
    background: '#28a745',
    color: 'white',
    border: 'none',
    padding: '12px',
    borderRadius: '8px',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '16px',
    minWidth: '80px',
    minHeight: '48px'
  }
};

const MobileStyles = () => {
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      input, select, textarea { font-size: 16px !important; }
      @media (max-width: 768px) {
        div[style*="overflowX: auto"] { -webkit-overflow-scrolling: touch; }
        table { min-width: 600px; }
        body { margin: 0; padding: 0; }
        input, select, textarea { font-size: 16px !important; }
        button { min-height: 44px; }
        .work-item-mobile { flex-direction: column; align-items: stretch !important; }
        .work-item-mobile input { width: 100%; }
        .stats-mobile { margin-top: 10px; width: 100%; justify-content: center; }
        .profit-row-mobile { flex-direction: column; }
        .profit-row-mobile > div { width: 100% !important; margin-bottom: 10px; }
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);
  return null;
};

// --- API НАСТРОЙКИ ---
const API_URL = 'https://inzhstroy-msk.ru/api';

// --- Компонент защиты паролем для главного приложения ---
const PasswordGuard = ({ children }) => {
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === 'toto26') {
      setIsAuthenticated(true);
    } else {
      alert('Неверный пароль!');
    }
  };

  if (isAuthenticated) return children;

  return (
    <div style={{ textAlign: 'center', marginTop: '100px' }}>
      <h2>🔒 Доступ к системе учёта ограничен</h2>
      <form onSubmit={handleSubmit} style={{ display: 'inline-block', marginTop: '20px' }}>
        <input
          type="password"
          placeholder="Введите пароль"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={styles.input}
          autoFocus
        />
        <button type="submit" style={{ ...styles.button, marginLeft: '10px' }}>Войти</button>
      </form>
    </div>
  );
};

// --- Компонент защиты для страницы рентабельности ---
const ProfitabilityGuard = ({ children }) => {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Жестко заданные учетные данные (передаются устно)
    if (login === 'admin' && password === 'profit2024!') {
      setIsAuthenticated(true);
    } else {
      alert('Неверный логин или пароль!');
    }
  };

  if (isAuthenticated) return children;

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h2>🔐 Доступ к странице "Рентабельность"</h2>
      <form onSubmit={handleSubmit} style={{ display: 'inline-block', marginTop: '20px' }}>
        <div style={{ marginBottom: '10px' }}>
          <input
            type="text"
            placeholder="Логин"
            value={login}
            onChange={(e) => setLogin(e.target.value)}
            style={styles.input}
          />
        </div>
        <div style={{ marginBottom: '10px' }}>
          <input
            type="password"
            placeholder="Пароль"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
          />
        </div>
        <button type="submit" style={styles.button}>Войти</button>
      </form>
    </div>
  );
};


// --- Страница 1: Учёт товаров (с поиском и Кэф) ---//
const InventoryPage = ({ items, setItems, onLoadItems }) => {
  const [form, setForm] = useState({ name: '', model: '', sku: '', cost: '', price: '', quantity: 1 });
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Отслеживаем размер экрана
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

    // Очистка поиска
  const clearSearch = () => {
    setSearchTerm('');
  };

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.cost || !form.price) {
      alert('Заполните обязательные поля: Название, Себестоимость, Цена реализации');
      return;
    }
    
    setLoading(true);
    try {
      if (editId !== null) {
        const updatedItem = { 
          id: editId,
          name: form.name,
          model: form.model || '',
          sku: form.sku || '',
          cost: parseFloat(form.cost),
          price: parseFloat(form.price),
          quantity: parseInt(form.quantity) || 0
        };
        await fetch(`${API_URL}/items.php`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(updatedItem)
        });
        setEditId(null);
      } else {
        const newItem = {
          name: form.name,
          model: form.model || '',
          sku: form.sku || '',
          cost: parseFloat(form.cost),
          price: parseFloat(form.price),
          quantity: parseInt(form.quantity) || 1
        };
        await fetch(`${API_URL}/items.php`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(newItem)
        });
      }
      
      await onLoadItems();
      setForm({ name: '', model: '', sku: '', cost: '', price: '', quantity: 1 });
      alert(editId ? '✅ Товар обновлён!' : '✅ Товар добавлен на склад!');
    } catch (error) {
      console.error('Ошибка сохранения:', error);
      alert('Ошибка при сохранении товара');
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (item) => {
    setForm({ 
      name: item.name, 
      model: item.model || '', 
      sku: item.sku || '', 
      cost: item.cost, 
      price: item.price, 
      quantity: item.quantity 
    });
    setEditId(item.id);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Удалить товар?')) return;
    
    setLoading(true);
    try {
      await fetch(`${API_URL}/items.php?id=${id}`, { method: 'DELETE' });
      await onLoadItems();
      alert('✅ Товар удалён');
    } catch (error) {
      console.error('Ошибка удаления:', error);
      alert('Ошибка при удалении товара');
    } finally {
      setLoading(false);
    }
  };

  // Фильтрация товаров по поиску (название, артикул, модель)
  const filteredItems = items.filter(item => {
    const searchLower = searchTerm.toLowerCase();
    return (
      item.name.toLowerCase().includes(searchLower) ||
      (item.sku && item.sku.toLowerCase().includes(searchLower)) ||
      (item.model && item.model.toLowerCase().includes(searchLower))
    );
  });

  const totalCost = items.reduce((sum, item) => sum + (item.cost * item.quantity), 0);
  const totalPrice = items.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  const coefficient = totalCost > 0 ? (totalPrice / totalCost).toFixed(2) : '0.00';

  return (
    <div>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        flexWrap: 'wrap', 
        marginBottom: '20px',
        flexDirection: isMobile ? 'column' : 'row',
        gap: isMobile ? '15px' : '0'
      }}>
        <h2 style={{ margin: 0, textAlign: isMobile ? 'center' : 'left' }}>📦 Учёт товаров (остатки)</h2>
        
        {/* Блок статистики - на мобильных вертикально */}
        <div className="stats-mobile" style={{ 
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          gap: isMobile ? '8px' : '20px',
          background: '#e9ecef',
          padding: isMobile ? '12px 15px' : '10px 20px',
          borderRadius: '8px',
          fontSize: '14px',
          width: isMobile ? '100%' : 'auto',
          boxSizing: 'border-box'
        }}>
          <span style={{ 
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '10px'
          }}>
            <span>💰 Сумма закуп:</span>
            <strong>{totalCost.toFixed(2)} ₽</strong>
          </span>
          <span style={{ 
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '10px'
          }}>
            <span>💵 Сумма реализации:</span>
            <strong>{totalPrice.toFixed(2)} ₽</strong>
          </span>
          <span style={{ 
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '10px'
          }}>
            <span>📈 Кэф:</span>
            <strong>⨯{coefficient}</strong>
          </span>
        </div>
      </div>

      <form style={styles.form} onSubmit={handleSubmit}>
        <div style={styles.formRow}>
          <input style={styles.input} name="name" placeholder="Название товара*" value={form.name} onChange={handleChange} required />
          <input style={styles.input} name="model" placeholder="К какой модели" value={form.model} onChange={handleChange} />
          <input style={styles.input} name="sku" placeholder="Артикул" value={form.sku} onChange={handleChange} />
          <input style={styles.input} name="cost" type="number" step="0.01" placeholder="Себестоимость*" value={form.cost} onChange={handleChange} required />
          <input style={styles.input} name="price" type="number" step="0.01" placeholder="Цена реализации*" value={form.price} onChange={handleChange} required />
          <input style={styles.input} name="quantity" type="number" placeholder="Количество" value={form.quantity} onChange={handleChange} />
        </div>
        <div>
          <button style={styles.button} type="submit" disabled={loading}>
            {loading ? '⏳ Сохранение...' : (editId ? '💾 Сохранить изменения' : '➕ Добавить на склад')}
          </button>
          {editId && <button style={{...styles.dangerButton, background:'#6c757d', marginLeft: '10px'}} onClick={() => { setEditId(null); setForm({ name: '', model: '', sku: '', cost: '', price: '', quantity: 1 }); }}>Отмена</button>}
        </div>
      </form>

      {/* Поле поиска - адаптировано для мобильных */}
      <div style={{ 
        marginBottom: '20px',
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        alignItems: isMobile ? 'stretch' : 'center',
        gap: '10px'
      }}>
        <div style={{ flex: 1, position: 'relative' }}>
          <input
            type="text"
            placeholder="🔍 Поиск по названию, модели или артикулу..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              ...styles.input,
              width: '100%',
              boxSizing: 'border-box',
              backgroundColor: '#fff',
              paddingRight: searchTerm ? '35px' : '12px'
            }}
          />
          {searchTerm && (
            <button
              onClick={clearSearch}
              style={{
                position: 'absolute',
                right: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontSize: '18px',
                color: '#999',
                padding: '5px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              title="Очистить поиск"
            >
              ✕
            </button>
          )}
        </div>
        {searchTerm && (
          <span style={{ 
            fontSize: '14px', 
            color: '#666',
            whiteSpace: 'nowrap',
            textAlign: 'center'
          }}>
            Найдено: {filteredItems.length} из {items.length}
          </span>
        )}
      </div>

      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={styles.thTd}>Название</th>
              <th style={styles.thTd}>Модель</th>
              <th style={styles.thTd}>Артикул</th>
              <th style={styles.thTd}>Себест.</th>
              <th style={styles.thTd}>Цена</th>
              <th style={styles.thTd}>Кол-во</th>
              <th style={styles.thTd}>Кэф</th>
              <th style={styles.thTd}>Действия</th>
            </tr>
          </thead>
          <tbody>
            {filteredItems.map(item => {
              const itemCoefficient = item.cost > 0 ? (item.price / item.cost).toFixed(2) : '0.00';
              return (
                <tr key={item.id}>
                  <td style={styles.thTd}>{item.name}</td>
                  <td style={styles.thTd}>{item.model || '-'}</td>
                  <td style={styles.thTd}>{item.sku || '-'}</td>
                  <td style={styles.thTd}>{item.cost} ₽</td>
                  <td style={styles.thTd}>{item.price} ₽</td>
                  <td style={styles.thTd}>{item.quantity}</td>
                  <td style={styles.thTd}>
                    <span style={{
                      fontWeight: 'bold',
                      color: itemCoefficient >= 1 ? '#28a745' : '#dc3545'
                    }}>
                      ⨯{itemCoefficient}
                    </span>
                  </td>
                  <td style={styles.thTd}>
                    <button style={styles.editButton} onClick={() => handleEdit(item)}>✏️</button>
                    <button style={styles.dangerButton} onClick={() => handleDelete(item.id)}>🗑️</button>
                  </td>
                </tr>
              );
            })}
            {filteredItems.length === 0 && (
              <tr>
                <td colSpan="8" style={{textAlign: 'center'}}>
                  {searchTerm ? '🔍 Ничего не найдено' : 'Нет товаров на складе'}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
// --- Страница 2: Выезды инженеров ---
// ============================================================
//  СТРАНИЦА 2: Выезды инженеров (ОБНОВЛЁННАЯ ВЕРСИЯ)
// ============================================================
// ============================================================
//  СТРАНИЦА 2: Выезды инженеров (ПОЛНАЯ ВЕРСИЯ)
// ============================================================
// ============================================================
//  СТРАНИЦА 2: Выезды инженеров (УПРОЩЁННАЯ ВЕРСИЯ)
// ============================================================
// ============================================================
//  СТРАНИЦА 2: Выезды инженеров (ФИНАЛЬНАЯ ВЕРСИЯ)
// ============================================================
const JobsPage = ({ items, setItems, jobs, setJobs, onLoadJobs, onLoadItems }) => {
  const [form, setForm] = useState({
    engineer: '', model: '', date: new Date().toISOString().slice(0,10),
    address: '', photo: ''
  });
  const [workItems, setWorkItems] = useState([{ id: Date.now(), name: '', price: '' }]);
  const [selectedStockItems, setSelectedStockItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // ============================================================
  //  РАСЧЁТЫ
  // ============================================================

  // Сумма текущего выезда
  const calculateCurrentSum = () => {
    const worksSum = workItems.reduce((sum, w) => sum + (parseFloat(w.price) || 0), 0);
    const stockSum = selectedStockItems.reduce((sum, s) => sum + (s.price * s.quantity), 0);
    return worksSum + stockSum;
  };

  // Расчёт итоговой суммы с вычетами (ПРАВИЛЬНЫЙ ПОРЯДОК)
  const calculateFinalSum = (totalSum, worksSum) => {
    // 1. Сис.админ (5% от общей суммы)
    const sysAdmin = totalSum * 0.05;
    
    // 2. НДС (6% от общей суммы)
    const nds = totalSum * 0.06;
    
    // 3. Оплата инженеру (50% от суммы работ)
    const engineerShare = worksSum * 0.5;
    
    // 4. Сумма после первых трёх вычетов
    const afterFirstDeductions = totalSum - sysAdmin - nds - engineerShare;
    
    // 5. Возврат (15% от суммы после первых трёх вычетов)
    const returnAmount = afterFirstDeductions * 0.15;
    
    // 6. Итоговая сумма
    const finalSum = afterFirstDeductions - returnAmount;
    
    return { 
      sysAdmin, 
      nds, 
      engineerShare, 
      returnAmount, 
      finalSum,
      afterFirstDeductions 
    };
  };

  // Расчёт для выезда из истории
  const calculateJobFinalSum = (job) => {
    const total = job.totalSum || 0;
    const worksTotal = job.works?.reduce((s, w) => s + (parseFloat(w.price) || 0), 0) || 0;
    const partsTotal = job.parts?.reduce((s, p) => s + (parseFloat(p.price) || 0) * (parseInt(p.quantity) || 1), 0) || 0;
    const worksSum = worksTotal;
    
    const sysAdmin = total * 0.05;
    const nds = total * 0.06;
    const engineerShare = worksSum * 0.5;
    const afterFirstDeductions = total - sysAdmin - nds - engineerShare;
    const returnAmount = afterFirstDeductions * 0.15;
    const finalSum = afterFirstDeductions - returnAmount;
    
    return { 
      total, 
      worksSum, 
      partsTotal, 
      sysAdmin, 
      nds, 
      engineerShare, 
      returnAmount, 
      finalSum,
      afterFirstDeductions 
    };
  };

  // ============================================================
  //  ОТОБРАЖЕНИЕ ДЕТАЛЬНОГО РАСЧЁТА В ИСТОРИИ
  // ============================================================
  const renderCalculationDetails = (job) => {
    const calc = calculateJobFinalSum(job);
    return (
      <div style={{ 
        fontSize: '11px', 
        marginTop: '4px', 
        padding: '4px 8px', 
        background: '#f8f9fa', 
        borderRadius: '4px', 
        border: '1px solid #e9ecef' 
      }}>
        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '1px 10px' }}>
          <span>💰 {calc.total.toFixed(2)} ₽</span>
          <span style={{ color: '#dc3545' }}>-5% сис.админ - {calc.sysAdmin.toFixed(2)}</span>
          <span style={{ color: '#dc3545' }}>-6% НДС - {calc.nds.toFixed(2)}</span>
          <span style={{ color: '#dc3545' }}>-50% инженеру - {calc.engineerShare.toFixed(2)}</span>
           <span style={{ 
            borderTop: '1px solid #007bff', 
            gridColumn: isMobile ? '1' : '1 / -1', 
            textAlign: 'center', 
            fontWeight: 'bold', 
            color: '#007bff',
            paddingTop: '4px'
          }}>
          </span>
          <span style={{ color: 'rgb(37, 155, 229)' }}>🔄 Сумма после вычетов: {calc.afterFirstDeductions.toFixed(2)}</span>
          <span style={{ color: 'rgb(37, 155, 229)' }}>-15% возврат - {calc.returnAmount.toFixed(2)}</span>
          <span style={{ 
            borderTop: '2px solid #007bff', 
            gridColumn: isMobile ? '1' : '1 / -1', 
            textAlign: 'center', 
            fontWeight: 'bold', 
            color: '#007bff',
            paddingTop: '4px'
          }}>
            💳 ИТОГО: {calc.finalSum.toFixed(2)} ₽
          </span>
        </div>
      </div>
    );
  };

  // ============================================================
  //  ОТПРАВКА ФОРМЫ
  // ============================================================
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!form.engineer || !form.model || !form.date || !form.address) {
      alert('Заполните обязательные поля: Кто поехал, модель, дата, адрес');
      return;
    }

    const validWorks = workItems.filter(w => w.name.trim());
    
    if (validWorks.length === 0 && selectedStockItems.length === 0) {
      alert('Добавьте хотя бы одну работу или деталь со склада!');
      return;
    }

    setLoading(true);
    
    try {
      // Списываем детали со склада
      for (const stockItem of selectedStockItems) {
        const item = items.find(i => i.id === stockItem.id);
        if (item) {
          const updatedItem = { ...item, quantity: item.quantity - stockItem.quantity };
          await fetch(`${API_URL}/items.php`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(updatedItem)
          });
        }
      }

      // Сохраняем выезд
      const totalSum = calculateCurrentSum();
      const worksSum = workItems.reduce((sum, w) => sum + (parseFloat(w.price) || 0), 0);
      const partsSum = selectedStockItems.reduce((sum, s) => sum + (s.price * s.quantity), 0);

      // ===== ФОРМИРУЕМ ДАННЫЕ КАК В МИНИАП =====
      const newJob = {
        who: form.engineer,
        date: form.date,
        address: form.address,
        model: form.model,
        photo: form.photo || '',
        works: validWorks.map(w => ({
          name: w.name,
          price: parseFloat(w.price) || 0
        })),
        parts: selectedStockItems.map(s => ({
          id: s.id,
          name: s.name,
          price: s.price,
          quantity: s.quantity
        })),
        participants: [],
        total_works: worksSum,
        total_parts: partsSum,
        total_sum: totalSum,
        sys_admin_sum: 0,
        final_sum: totalSum
      };

      const response = await fetch(`${API_URL}/miniapp_api.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newJob)
      });

      const result = await response.json();

      if (result.success) {
        await onLoadItems();
        await onLoadJobs();

        setForm({ 
          engineer: '', 
          model: '', 
          date: new Date().toISOString().slice(0,10), 
          address: '', 
          photo: '' 
        });
        setWorkItems([{ id: Date.now(), name: '', price: '' }]);
        setSelectedStockItems([]);

        const finalCalc = calculateFinalSum(totalSum, worksSum);
        alert(`✅ Выезд сохранён!\n\n` +
          `💰 Общая сумма: ${totalSum.toFixed(2)} ₽\n` +
          `🔩 Запчасти: ${partsSum.toFixed(2)} ₽\n` +
          `💎 Работы: ${worksSum.toFixed(2)} ₽\n` +
          `👥 50% инженеру: ${(worksSum / 2).toFixed(2)} ₽\n\n` +
          `📊 После вычетов:\n` +
          `👨‍💻 Сис.админ (5% от общ.): -${finalCalc.sysAdmin.toFixed(2)} ₽\n` +
          `📊 НДС (6% от общ.): -${finalCalc.nds.toFixed(2)} ₽\n` +
          `👥 Оплата (50% от работ): -${finalCalc.engineerShare.toFixed(2)} ₽\n` +
          `🔄 Сумма после вычетов: ${finalCalc.afterFirstDeductions.toFixed(2)} ₽\n` +
          `🔄 Возврат (15% от суммы после вычетов): -${finalCalc.returnAmount.toFixed(2)} ₽\n` +
          `💳 ИТОГО: ${finalCalc.finalSum.toFixed(2)} ₽`);
      } else {
        alert(`❌ Ошибка: ${result.error || 'Неизвестная ошибка'}`);
      }
    } catch (error) {
      console.error('Ошибка сохранения выезда:', error);
      alert('Ошибка при сохранении выезда');
    } finally {
      setLoading(false);
    }
  };

  // ============================================================
  //  РАБОТА С РАБОТАМИ
  // ============================================================
  const addWorkItem = () => {
    setWorkItems([...workItems, { id: Date.now(), name: '', price: '' }]);
  };

  const removeWorkItem = (id) => {
    if (workItems.length === 1) {
      alert('Должна быть хотя бы одна работа');
      return;
    }
    setWorkItems(workItems.filter(w => w.id !== id));
  };

  const updateWorkItem = (id, field, value) => {
    setWorkItems(workItems.map(w => w.id === id ? { ...w, [field]: value } : w));
  };

  // ============================================================
  //  РАБОТА СО СКЛАДОМ
  // ============================================================
  const addStockItem = (itemId) => {
    const item = items.find(i => i.id === parseInt(itemId));
    if (!item) return;
    if (item.quantity <= 0) {
      alert('Товара нет в наличии!');
      return;
    }
    const existing = selectedStockItems.find(s => s.id === item.id);
    if (existing) {
      if (existing.quantity + 1 > item.quantity) {
        alert(`Нельзя добавить больше, чем есть на складе (${item.quantity} шт.)`);
        return;
      }
      setSelectedStockItems(selectedStockItems.map(s => 
        s.id === item.id ? { ...s, quantity: s.quantity + 1 } : s
      ));
    } else {
      setSelectedStockItems([...selectedStockItems, { 
        id: item.id, 
        name: item.name, 
        price: item.price, 
        quantity: 1 
      }]);
    }
  };

  const removeStockItem = (id) => {
    setSelectedStockItems(selectedStockItems.filter(s => s.id !== id));
  };

  const updateStockQuantity = (id, newQty) => {
    const item = items.find(i => i.id === id);
    if (!item) return;
    if (newQty > item.quantity) {
      alert(`На складе только ${item.quantity} шт.`);
      return;
    }
    if (newQty <= 0) {
      removeStockItem(id);
    } else {
      setSelectedStockItems(selectedStockItems.map(s => 
        s.id === id ? { ...s, quantity: newQty } : s
      ));
    }
  };

  // ============================================================
  //  СТАТИСТИКА
  // ============================================================

  // Общая сумма всех выездов
  const totalJobsSum = jobs.reduce((sum, job) => {
    const worksTotal = job.works?.reduce((s, w) => s + (parseFloat(w.price) || 0), 0) || 0;
    const partsTotal = job.parts?.reduce((s, p) => s + (parseFloat(p.price) || 0) * (parseInt(p.quantity) || 1), 0) || 0;
    return sum + worksTotal + partsTotal;
  }, 0);

  // Сумма работ (без запчастей)
  const totalWorksSum = jobs.reduce((sum, job) => {
    const worksTotal = job.works?.reduce((s, w) => s + (parseFloat(w.price) || 0), 0) || 0;
    return sum + worksTotal;
  }, 0);

  // Сумма запчастей
  const totalPartsSum = jobs.reduce((sum, job) => {
    const partsTotal = job.parts?.reduce((s, p) => s + (parseFloat(p.price) || 0) * (parseInt(p.quantity) || 1), 0) || 0;
    return sum + partsTotal;
  }, 0);

  // Расчёты для статистики (ПРАВИЛЬНЫЙ ПОРЯДОК)
  const totalSysAdmin = totalJobsSum * 0.05;
  const totalNds = totalJobsSum * 0.06;
  const totalEngineerShare = totalWorksSum * 0.5;
  const totalAfterFirstDeductions = totalJobsSum - totalSysAdmin - totalNds - totalEngineerShare;
  const totalReturn = totalAfterFirstDeductions * 0.15;
  const totalFinalSum = totalAfterFirstDeductions - totalReturn;

  // Текущий выезд
  const currentSum = calculateCurrentSum();
  const currentWorksSum = workItems.reduce((sum, w) => sum + (parseFloat(w.price) || 0), 0);
  const currentPartsSum = selectedStockItems.reduce((sum, s) => sum + (s.price * s.quantity), 0);
  const currentCalc = calculateFinalSum(currentSum, currentWorksSum);

  // ============================================================
  //  РЕНДЕРИНГ
  // ============================================================
  return (
    <div>
      {/* ============================================================
          БЛОК СТАТИСТИКИ
          ============================================================ */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        flexWrap: 'wrap', 
        marginBottom: '20px',
        gap: '15px'
      }}>
        <h2>🔧 Выезды инженеров</h2>
        <div style={{ 
          ...styles.stats, 
          padding: '15px 25px', 
          fontSize: '16px',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          borderRadius: '12px',
          minWidth: isMobile ? '100%' : '350px',
          boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
          boxSizing: 'border-box'
        }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '100%' }}>
            {/* Общая сумма */}
            <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(255,255,255,0.2)', paddingBottom: '6px' }}>
              <span>💰 Общая сумма выездов:</span>
              <strong style={{ fontSize: '18px' }}>{totalJobsSum.toFixed(2)} ₽</strong>
            </div>
            
            {/* Работы и запчасти */}
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', opacity: 0.9 }}>
              <span>💎 Работы:</span>
              <span>{totalWorksSum.toFixed(2)} ₽</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', opacity: 0.9, borderBottom: '1px solid rgba(255,255,255,0.2)', paddingBottom: '6px' }}>
              <span>🔩 Запчасти:</span>
              <span>{totalPartsSum.toFixed(2)} ₽</span>
            </div>
            
            {/* Вычеты от общей суммы */}
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', opacity: 0.9 }}>
              <span>👨‍💻 Сис.админ (5% от общ.):</span>
              <span style={{ color: '#ffd700' }}>-{totalSysAdmin.toFixed(2)} ₽</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', opacity: 0.9, borderBottom: '1px solid rgba(255,255,255,0.2)', paddingBottom: '6px' }}>
              <span>📊 НДС (6% от общ.):</span>
              <span style={{ color: '#ffd700' }}>-{totalNds.toFixed(2)} ₽</span>
            </div>
            
            {/* Вычеты от суммы работ */}
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', opacity: 0.9 }}>
              <span>👥 Оплата инженеру (50% от работ):</span>
              <span style={{ color: '#ffd700' }}>-{totalEngineerShare.toFixed(2)} ₽</span>
            </div>
            
            {/* Сумма после вычетов и возврат */}
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', opacity: 0.9, borderBottom: '1px solid rgba(255,255,255,0.2)', paddingBottom: '6px' }}>
              <span>🔄 Сумма после вычетов:</span>
              <span style={{ color: '#90EE90' }}>{totalAfterFirstDeductions.toFixed(2)} ₽</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', opacity: 0.9, borderBottom: '1px solid rgba(255,255,255,0.2)', paddingBottom: '6px' }}>
              <span>🔄 Возврат (15% от суммы после вычетов):</span>
              <span style={{ color: '#ffd700' }}>-{totalReturn.toFixed(2)} ₽</span>
            </div>
            
            {/* Итог */}
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              borderTop: '2px solid rgba(255,255,255,0.3)', 
              paddingTop: '6px',
              marginTop: '4px',
              fontSize: '17px',
              fontWeight: 'bold'
            }}>
              <span>💳 ИТОГО:</span>
              <span style={{ color: '#ffd700' }}>{totalFinalSum.toFixed(2)} ₽</span>
            </div>
          </div>
        </div>
      </div>

      {/* ============================================================
          ФОРМА
          ============================================================ */}
      <form onSubmit={handleSubmit} style={styles.form}>
        {/* Блок суммы текущего выезда */}
        <div style={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          padding: '16px',
          borderRadius: '12px',
          marginBottom: '20px'
        }}>
          <div style={{ fontSize: '13px', opacity: 0.9, marginBottom: '6px' }}>💰 СУММА ТЕКУЩЕГО ВЫЕЗДА</div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '20px', fontWeight: 'bold' }}>
            <span>💎 Общая сумма:</span>
            <span style={{ color: '#ffd700' }}>{currentSum.toFixed(2)} ₽</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', opacity: 0.9, marginTop: '4px' }}>
            <span>📝 Работы: {currentWorksSum.toFixed(2)} ₽</span>
            <span>🔩 Запчасти: {currentPartsSum.toFixed(2)} ₽</span>
          </div>
        </div>

        {/* Основные поля */}
        <div style={styles.formRow}>
          <input 
            style={styles.input} 
            name="engineer" 
            placeholder="Кто поехал*" 
            value={form.engineer} 
            onChange={(e) => setForm({...form, engineer: e.target.value})} 
            required 
          />
          <input 
            style={styles.input} 
            name="model" 
            placeholder="Какая модель*" 
            value={form.model} 
            onChange={(e) => setForm({...form, model: e.target.value})} 
            required 
          />
          <input 
            style={styles.input} 
            name="date" 
            type="date" 
            value={form.date} 
            onChange={(e) => setForm({...form, date: e.target.value})} 
            required 
          />
          <input 
            style={styles.input} 
            name="address" 
            placeholder="Адрес*" 
            value={form.address} 
            onChange={(e) => setForm({...form, address: e.target.value})} 
            required 
          />
        </div>

        {/* Работы */}
        <div>
          <label><strong>📝 Что сделал (работы/услуги):</strong></label>
          {workItems.map((item) => (
            <div 
              key={item.id} 
              className="work-item-mobile" 
              style={isMobile ? { ...styles.workItem, flexDirection: 'column', alignItems: 'stretch' } : styles.workItem}
            >
              <input 
                style={{...styles.input, flex: 2, width: isMobile ? '100%' : 'auto'}} 
                placeholder="Наименование работы" 
                value={item.name} 
                onChange={(e) => updateWorkItem(item.id, 'name', e.target.value)} 
              />
              <input 
                style={{...styles.input, flex: 1, width: isMobile ? '100%' : 'auto', maxWidth: isMobile ? '100%' : '120px'}} 
                type="number" 
                step="0.01" 
                placeholder="Цена" 
                value={item.price} 
                onChange={(e) => updateWorkItem(item.id, 'price', e.target.value)} 
              />
              <button 
                type="button" 
                style={styles.dangerButton} 
                onClick={() => removeWorkItem(item.id)}
              >
                🗑️
              </button>
            </div>
          ))}
          <button type="button" style={styles.addButton} onClick={addWorkItem}>
            ➕ Добавить работу
          </button>
        </div>

        {/* Выбор деталей со склада */}
        <div>
          <label><strong>📦 Выбрать детали со склада:</strong></label>
          <select 
            style={{...styles.input, width: '100%', marginBottom: '10px'}} 
            onChange={(e) => addStockItem(e.target.value)} 
            value=""
          >
            <option value="">-- Выберите деталь --</option>
            {items.filter(i => i.quantity > 0).map(item => (
              <option key={item.id} value={item.id}>
                {item.name} (остаток: {item.quantity}, цена: {item.price}₽)
              </option>
            ))}
          </select>
          
          {selectedStockItems.length > 0 && (
            <div style={{ marginTop: '10px' }}>
              {selectedStockItems.map(s => (
                <div 
                  key={s.id} 
                  style={{
                    background: '#e9ecef',
                    padding: isMobile ? '12px' : '8px 12px',
                    borderRadius: '6px',
                    marginBottom: '8px',
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    alignItems: isMobile ? 'stretch' : 'center',
                    gap: isMobile ? '8px' : '10px'
                  }}
                >
                  <span style={{ flex: 2, fontWeight: '500' }}>{s.name}</span>
                  
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{ fontSize: '14px', color: '#666' }}>Кол-во:</span>
                    <input 
                      type="number" 
                      min="1" 
                      max={items.find(i => i.id === s.id)?.quantity} 
                      value={s.quantity} 
                      onChange={(e) => updateStockQuantity(s.id, parseInt(e.target.value) || 1)} 
                      style={{ 
                        width: isMobile ? '70px' : '60px', 
                        padding: '6px', 
                        borderRadius: '4px', 
                        border: '1px solid #ccc', 
                        fontSize: '14px', 
                        textAlign: 'center' 
                      }} 
                    />
                  </div>
                  
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{ fontSize: '14px', color: '#666' }}>Цена:</span>
                    <span style={{ fontWeight: 'bold' }}>{s.price} ₽/шт</span>
                  </div>
                  
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{ fontSize: '14px', color: '#666' }}>Сумма:</span>
                    <span style={{ fontWeight: 'bold', color: '#007bff' }}>
                      {(s.price * s.quantity).toFixed(2)} ₽
                    </span>
                  </div>
                  
                  <button 
                    type="button" 
                    style={{...styles.dangerButton, marginRight: 0}} 
                    onClick={() => removeStockItem(s.id)}
                  >
                    🗑️
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        <div style={styles.formRow}>
          <input 
            style={styles.input} 
            name="photo" 
            placeholder="Ссылка на фото (не обязательно)" 
            value={form.photo} 
            onChange={(e) => setForm({...form, photo: e.target.value})} 
          />
        </div>

        <div style={styles.centerButton}>
          <button 
            style={{...styles.button, backgroundColor: '#007bff', padding: '12px 30px'}} 
            type="submit" 
            disabled={loading}
          >
            {loading ? '⏳ Сохранение...' : '✅ Сохранить выезд и списать товар'}
          </button>
        </div>
      </form>

      {/* ============================================================
          ИСТОРИЯ ВЫЕЗДОВ
          ============================================================ */}
      <h3>📋 История выездов</h3>
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={styles.thTd}>Дата</th>
              <th style={styles.thTd}>Инженер</th>
              <th style={styles.thTd}>Модель</th>
              <th style={styles.thTd}>Адрес</th>
              <th style={styles.thTd}>Сделано</th>
              <th style={styles.thTd}>Сумма</th>
              <th style={styles.thTd}>Фото</th>
            </tr>
          </thead>
          <tbody>
            {jobs.map(job => {
              // Считаем суммы из данных
              const worksTotal = job.works?.reduce((s, w) => s + (parseFloat(w.price) || 0), 0) || 0;
              const partsTotal = job.parts?.reduce((s, p) => s + (parseFloat(p.price) || 0) * (parseInt(p.quantity) || 1), 0) || 0;
              const totalSum = worksTotal + partsTotal;
              
              return (
                <tr key={job.id}>
                  <td style={styles.thTd}>{job.date}</td>
                  <td style={styles.thTd}>{job.engineer || job.who}</td>
                  <td style={styles.thTd}>{job.model}</td>
                  <td style={styles.thTd}>{job.address}</td>
                  <td style={styles.thTd}>
                    {job.works?.map((w, i) => (
                      <div key={i}>• {w.name} — {w.price}₽</div>
                    ))}
                    {job.parts?.map((p, i) => (
                      <div key={i}>📦 {p.name} x{p.quantity} — {p.price * p.quantity}₽</div>
                    ))}
                    {/* Детальный расчёт */}
                    {totalSum > 0 && renderCalculationDetails(job)}
                  </td>
                  <td style={styles.thTd}>
                    <div><strong>{totalSum.toFixed(2)} ₽</strong></div>
                    <div style={{ fontSize: '12px', color: '#666' }}>
                      💎 Работы: {worksTotal.toFixed(2)} ₽
                    </div>
                    <div style={{ fontSize: '12px', color: '#666' }}>
                      🔩 Запчасти: {partsTotal.toFixed(2)} ₽
                    </div>
                    <div style={{ fontSize: '12px', color: '#007bff', fontWeight: 'bold' }}>
                      💳 ИТОГО: {calculateJobFinalSum(job).finalSum.toFixed(2)} ₽
                    </div>
                  </td>
                  <td style={styles.thTd}>
                    {job.photo && <a href={job.photo} target="_blank" rel="noreferrer">📸 Фото</a>}
                  </td>
                </tr>
              );
            })}
            {jobs.length === 0 && (
              <tr>
                <td colSpan="7" style={{textAlign: 'center'}}>Нет выездов</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
// --- СТРАНИЦА 3: Рентабельность (с учетом товаров на складе) ---
const ProfitabilityPage = () => {
  const [usersData, setUsersData] = useState({
    andrey: { name: 'Андрей', profitability: 0, invested: 0, debt: 0 },
    yuriy: { name: 'Юрий', profitability: 0, invested: 0, debt: 0 }
  });
  const [activeAsset, setActiveAsset] = useState(0);
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [hasFile, setHasFile] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [items, setItems] = useState([]);
  const [jobs, setJobs] = useState([]);
  
  // Форма ввода (ДОБАВЛЯЕМ comment)
  const [form, setForm] = useState({
    user: 'andrey',
    amount: '',
    type: 'prihod',
    receiptFile: null,
    comment: ''  // НОВОЕ ПОЛЕ
  });
  
  // Отслеживаем размер экрана для мобильной версии
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  // Загрузка данных с сервера
  const loadData = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/profitability.php`);
      const data = await response.json();
      if (!data.error) {
        setUsersData(data.usersData);
        setActiveAsset(data.activeAsset);
        setHistory(data.history || []);
      }
    } catch (error) {
      console.error('Ошибка загрузки данных:', error);
    } finally {
      setLoading(false);
    }
  };
  
  // Загрузка товаров и выездов
  const loadItemsAndJobs = async () => {
    try {
      const [itemsRes, jobsRes] = await Promise.all([
        fetch(`${API_URL}/items.php`),
        fetch(`${API_URL}/jobs.php`)
      ]);
      const itemsData = await itemsRes.json();
      const jobsData = await jobsRes.json();
      setItems(Array.isArray(itemsData) ? itemsData : []);
      setJobs(Array.isArray(jobsData) ? jobsData : []);
    } catch (error) {
      console.error('Ошибка загрузки данных:', error);
      setItems([]);
      setJobs([]);
    }
  };
  
  // Загрузка файла на сервер
  const uploadFile = async (file) => {
    const formData = new FormData();
    formData.append('receipt', file);
    
    try {
      const response = await fetch(`${API_URL}/upload.php`, {
        method: 'POST',
        body: formData
      });
      const result = await response.json();
      if (result.success) {
        return result.filename;
      } else {
        alert('Ошибка загрузки файла: ' + result.error);
        return null;
      }
    } catch (error) {
      console.error('Ошибка загрузки файла:', error);
      return null;
    }
  };
  
  // Сохранение данных на сервер (ДОБАВЛЯЕМ comment)
  const saveData = async (newUsersData, newActiveAsset, operation) => {
    try {
      const response = await fetch(`${API_URL}/profitability.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          usersData: newUsersData,
          activeAsset: newActiveAsset,
          operation: {
            type: operation.type,
            userName: operation.userName,
            amount: operation.amount,
            description: operation.description,
            comment: operation.comment || '',  // ДОБАВЛЯЕМ
            receiptFile: operation.receiptFile
          }
        })
      });
      const result = await response.json();
      return result.success;
    } catch (error) {
      console.error('Ошибка сохранения:', error);
      return false;
    }
  };
  
  // Отмена последней операции
  const undoLastOperation = async () => {
    if (!window.confirm('Отменить последнюю операцию?')) return;
    
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/profitability.php`, {
        method: 'DELETE'
      });
      const result = await response.json();
      
      if (result.success && result.data) {
        setUsersData(result.data.usersData);
        setActiveAsset(result.data.activeAsset);
        await loadData();
        
        if (result.data.cancelledOperation) {
          alert(`✅ Операция отменена!\n\nОтменено: ${result.data.cancelledOperation}`);
        } else {
          alert('✅ Последняя операция отменена!');
        }
      } else if (result.error) {
        alert(result.error);
      }
    } catch (error) {
      console.error('Ошибка отмены операции:', error);
      alert('Ошибка при отмене операции');
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    loadData();
    loadItemsAndJobs();
  }, []);
  
  // Функция добавления записи в историю (ДОБАВЛЯЕМ comment)
  const addToHistory = (userName, amount, type, receiptFile, description, comment) => {
    const historyEntry = {
      id: Date.now(),
      created_at: new Date().toISOString(),
      user_name: userName,
      amount: amount,
      operation_type: type,
      description: description,
      comment: comment || '',  // ДОБАВЛЯЕМ
      receipt_file: receiptFile
    };
    setHistory(prev => [historyEntry, ...prev]);
  };
  
  // Вычисление дивидендов из истории
  const calculateDividends = () => {
    let andreyDividends = 0;
    let yuriyDividends = 0;
    
    if (Array.isArray(history)) {
      history.forEach(item => {
        if (!item.cancelled) {
          if (item.operation_type === 'dividendsOne') {
            if (item.user_name === 'Андрей') {
              andreyDividends += Number(item.amount) || 0;
            } else if (item.user_name === 'Юрий') {
              yuriyDividends += Number(item.amount) || 0;
            }
          } else if (item.operation_type === 'dividendsAll') {
            const halfAmount = (Number(item.amount) || 0) / 2;
            andreyDividends += halfAmount;
            yuriyDividends += halfAmount;
          }
        }
      });
    }
    
    return { andreyDividends, yuriyDividends };
  };
  
  const { andreyDividends, yuriyDividends } = calculateDividends();
  
  // Основная логика обработки операций
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!form.receiptFile) {
      alert('❌ Чек обязателен! Пожалуйста, прикрепите фото или PDF чека.');
      return;
    }
    
    const amount = parseFloat(form.amount);
    if (isNaN(amount) || amount <= 0) {
      alert('Введите корректную сумму!');
      return;
    }
    
    setLoading(true);
    
    let uploadedFilename = null;
    if (form.receiptFile) {
      setUploading(true);
      uploadedFilename = await uploadFile(form.receiptFile);
      setUploading(false);
      if (!uploadedFilename && form.receiptFile) {
        setLoading(false);
        return;
      }
    }
    
    let newUsersData = JSON.parse(JSON.stringify(usersData));
    let newActiveAsset = activeAsset;
    let operationDescription = '';
    let operationType = '';
    
    const currentUser = form.user === 'andrey' ? 'andrey' : 'yuriy';
    const otherUser = currentUser === 'andrey' ? 'yuriy' : 'andrey';
    const userName = newUsersData[currentUser].name;
    
    switch (form.type) {
      case 'prihod':
        const halfAmount = amount / 2;
        newUsersData[currentUser].profitability += halfAmount;
        newUsersData[otherUser].profitability += halfAmount;
        newActiveAsset += amount;
        operationDescription = `💰 Приход ${amount.toFixed(2)}₽ распределён 50/50`;
        operationType = 'prihod';
        break;
        
      case 'vlivaniya':
        // ИСПРАВЛЕНА ЛОГИКА: вливания распределяются 50/50 на рентабельность
        const halfInvestment = amount / 2;
        newUsersData[currentUser].invested += amount;
        newUsersData[currentUser].profitability += halfInvestment;
        newUsersData[otherUser].profitability += halfInvestment;
        newActiveAsset += amount;
        operationDescription = `💵 ${newUsersData[currentUser].name} влил ${amount.toFixed(2)}₽ (распределено 50/50: +${halfInvestment.toFixed(2)}₽ каждому)`;
        operationType = 'vlivaniya';
        break;
        
  case 'vernul':
  // Возврат из вливаний - списывается 50/50 с рентабельности
  if (newUsersData[currentUser].invested >= amount) {
    newUsersData[currentUser].invested -= amount;
    
    const halfReturn = amount / 2;
    newUsersData[currentUser].profitability -= halfReturn;
    newUsersData[otherUser].profitability -= halfReturn;
    newActiveAsset -= amount;
    
    operationDescription = `🔄 ${newUsersData[currentUser].name} вернул ${amount.toFixed(2)}₽ из вливаний (списано 50/50: -${halfReturn.toFixed(2)}₽ каждому)`;
    operationType = 'vernul';
  } else {
    alert(`Сумма возврата (${amount}₽) превышает сумму вливаний (${newUsersData[currentUser].invested.toFixed(2)}₽)!`);
    setLoading(false);
    return;
  }
  break;
        
      case 'zakup':
        const halfZakup = amount / 2;
        newUsersData[currentUser].profitability -= halfZakup;
        newUsersData[otherUser].profitability -= halfZakup;
        newActiveAsset -= amount;
        operationDescription = `🛒 Закуп на ${amount.toFixed(2)}₽`;
        operationType = 'zakup';
        break;
        
      case 'dolg':
        newUsersData[currentUser].debt -= amount;
        newUsersData[otherUser].debt += amount;
        newUsersData[currentUser].profitability -= amount;
        newUsersData[otherUser].profitability += amount;
        operationDescription = `📝 ${newUsersData[currentUser].name} дал в долг ${amount.toFixed(2)}₽ ${newUsersData[otherUser].name}`;
        operationType = 'dolg';
        break;
        
      case 'dividendsOne':
        newUsersData[currentUser].profitability += amount;
        newActiveAsset -= amount;
        operationDescription = `🎯 Дивиденды ${newUsersData[currentUser].name}: +${amount.toFixed(2)}₽`;
        operationType = 'dividendsOne';
        break;
        
      case 'dividendsAll':
        const halfDiv = amount / 2;
        newUsersData[currentUser].profitability += halfDiv;
        newUsersData[otherUser].profitability += halfDiv;
        newActiveAsset -= amount;
        operationDescription = `👥 Дивиденды всем: ${amount.toFixed(2)}₽`;
        operationType = 'dividendsAll';
        break;
        
      default:
        break;
    }
    
    const operation = {
      type: operationType,
      userName: userName,
      amount: amount,
      description: operationDescription,
      comment: form.comment,  // ДОБАВЛЯЕМ
      receiptFile: uploadedFilename
    };
    
    const saved = await saveData(newUsersData, newActiveAsset, operation);
    
    if (saved) {
      setUsersData(newUsersData);
      setActiveAsset(newActiveAsset);
      addToHistory(userName, amount, operationType, uploadedFilename, operationDescription, form.comment);
      
      setForm({
        user: 'andrey',
        amount: '',
        type: 'prihod',
        receiptFile: null,
        comment: ''  // ОЧИЩАЕМ
      });
      setHasFile(false);
      
      alert(`✅ Операция выполнена!\n${operationDescription}`);
    } else {
      alert('❌ Ошибка при сохранении операции');
    }
    
    setLoading(false);
  };
  
  // Обработчик выбора файла
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setForm({...form, receiptFile: file});
    setHasFile(!!file);
  };
  
  // Вычисление данных для информационного табло
  const totalCost = Array.isArray(items) ? items.reduce((sum, item) => sum + ((item.cost || 0) * (item.quantity || 0)), 0) : 0;
  const totalPrice = Array.isArray(items) ? items.reduce((sum, item) => sum + ((item.price || 0) * (item.quantity || 0)), 0) : 0;
  const coefficient = totalCost > 0 ? (totalPrice / totalCost).toFixed(2) : '0.00';
  const totalJobsSum = Array.isArray(jobs) ? jobs.reduce((sum, job) => {
    const worksTotal = job.workItems?.reduce((s, w) => s + (parseFloat(w.price) || 0), 0) || 0;
    const stockTotal = job.selectedStockItems?.reduce((s, st) => s + ((st.price || 0) * (st.quantity || 0)), 0) || 0;
    return sum + worksTotal + stockTotal;
  }, 0) : 0;
  
  // НОВАЯ ЛОГИКА: Расчет актива с учетом товаров на складе
  const calculatedTotalAsset = activeAsset - totalCost;
  const halfCalculatedAsset = calculatedTotalAsset / 2;
  
  // Корректировка рентабельности пользователей с учетом товаров
  const adjustedAndreyProfitability = (usersData.andrey?.profitability || 0) - (totalCost / 2);
  const adjustedYuriyProfitability = (usersData.yuriy?.profitability || 0) - (totalCost / 2);
  
  // Функция генерации PDF отчета 
  const generatePDF = () => {
    if (loading) {
      alert('Данные еще загружаются, подождите немного...');
      return;
    }
    
    const printWindow = window.open('', '_blank');
    if (!printWindow) {
      alert('Пожалуйста, разрешите всплывающие окна для этого сайта');
      return;
    }
    
    const currentDate = new Date().toLocaleString('ru-RU');
    
    // Расчет вливаний с учетом долгов
    const calculateTotalInvestments = () => {
      let andreyTotal = (usersData.andrey?.invested || 0);
      let yuriyTotal = (usersData.yuriy?.invested || 0);
      
      if (Array.isArray(history)) {
        history.forEach(item => {
          if (!item.cancelled && item.operation_type === 'dolg') {
            if (item.user_name === 'Андрей') {
              andreyTotal += Number(item.amount) || 0;
            } else if (item.user_name === 'Юрий') {
              yuriyTotal += Number(item.amount) || 0;
            }
          }
        });
      }
      
      return { andreyTotal, yuriyTotal };
    };
    
    const { andreyTotal, yuriyTotal } = calculateTotalInvestments();
    
    const getDebtInfo = () => {
      const andreyDebt = usersData.andrey?.debt || 0;
      const yuriyDebt = usersData.yuriy?.debt || 0;
      
      if (andreyDebt > 0) {
        return `👤 Андрей должен Юрию ${Math.abs(andreyDebt).toFixed(2)} ₽`;
      } else if (andreyDebt < 0) {
        return `👤 Юрий должен Андрею ${Math.abs(andreyDebt).toFixed(2)} ₽`;
      } else {
        return `💰 Нет задолженностей между участниками`;
      }
    };
    
    const escapeHtml = (str) => {
      if (str === undefined || str === null) return '';
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    };
    
    const reportHTML = `<!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
      <title>Полный отчет - ТОТОСЕРВИС</title>
      <style>
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { font-family: 'Arial', sans-serif; margin: 40px; padding: 20px; background: white; }
        .header { text-align: center; margin-bottom: 30px; padding-bottom: 20px; border-bottom: 2px solid #007bff; }
        .header h1 { color: #007bff; margin: 0 0 10px 0; font-size: 24px; }
        .header p { color: #666; margin: 5px 0; font-size: 12px; }
        .section { margin-bottom: 25px; page-break-inside: avoid; }
        .section-title { font-size: 16px; font-weight: bold; color: #007bff; margin-bottom: 12px; padding-bottom: 5px; border-bottom: 1px solid #dee2e6; }
        .info-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 15px; margin-bottom: 15px; }
        .info-card { background: #f8f9fa; padding: 12px; border-radius: 8px; border-left: 3px solid #007bff; }
        .info-card h4 { margin: 0 0 8px 0; color: #333; font-size: 14px; }
        .info-card .value { font-size: 18px; font-weight: bold; color: #007bff; }
        .compact-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; margin-bottom: 15px; }
        .compact-card { background: #f8f9fa; padding: 8px 12px; border-radius: 6px; text-align: center; }
        .compact-card .label { font-size: 11px; color: #666; margin-bottom: 4px; }
        .compact-card .value { font-size: 16px; font-weight: bold; color: #007bff; }
        .total-card { background: #e3f2fd; padding: 8px 12px; border-radius: 6px; text-align: center; margin-bottom: 15px; }
        .total-card .label { font-size: 12px; color: #666; margin-bottom: 4px; }
        .total-card .value { font-size: 18px; font-weight: bold; color: #0056b3; }
        .debt-row { background: #fff3cd; padding: 10px 15px; border-radius: 8px; margin-bottom: 20px; text-align: center; border-left: 4px solid #ffc107; }
        .debt-row .debt-text { font-size: 14px; font-weight: bold; color: #856404; }
        table { width: 100%; border-collapse: collapse; margin-bottom: 20px; font-size: 12px; }
        th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
        th { background: #f8f9fa; font-weight: bold; }
        .footer { margin-top: 30px; padding-top: 15px; border-top: 1px solid #dee2e6; text-align: center; font-size: 11px; color: #666; }
        @media print { body { margin: 0; padding: 15px; } .no-print { display: none; } }
      </style>
    </head>
    <body>
      <div class="header">
        <h1>📊 ТОТО СЕРВИС - Полный отчет</h1>
        <p>Дата формирования: ${escapeHtml(currentDate)}</p>
      </div>
      
      <!-- ПЕРВЫЙ БЛОК: Вливания участников -->
      <div class="section">
        <div class="section-title">💰 Вливания участников (включая выданные долги)</div>
        <div class="info-grid">
          <div class="info-card"><h4>👤 Андрей</h4><div class="value">${andreyTotal.toFixed(2)} ₽</div></div>
          <div class="info-card"><h4>👤 Юрий</h4><div class="value">${yuriyTotal.toFixed(2)} ₽</div></div>
        </div>
      </div>
      
      <!-- ВТОРОЙ БЛОК: Рентабельность (с учетом товаров) -->
      <div class="section">
        <div class="section-title">📈 Рентабельность (с учетом товаров на складе)</div>
        <div class="info-grid">
          <div class="info-card" style="border-left-color: ${adjustedAndreyProfitability >= 0 ? '#28a745' : '#dc3545'}">
            <h4>👤 Андрей</h4>
            <div class="value" style="color: ${adjustedAndreyProfitability >= 0 ? '#28a745' : '#dc3545'}">
              ${adjustedAndreyProfitability.toFixed(2)} ₽
            </div>
          </div>
          <div class="info-card" style="border-left-color: ${adjustedYuriyProfitability >= 0 ? '#28a745' : '#dc3545'}">
            <h4>👤 Юрий</h4>
            <div class="value" style="color: ${adjustedYuriyProfitability >= 0 ? '#28a745' : '#dc3545'}">
              ${adjustedYuriyProfitability.toFixed(2)} ₽
            </div>
          </div>
        </div>
      </div>
      
      <!-- Информация о долгах -->
      <div class="debt-row">
        <div class="debt-text">${escapeHtml(getDebtInfo())}</div>
      </div>
      
      <!-- ТРЕТИЙ БЛОК: Товарные остатки -->
      <div class="section">
        <div class="section-title">📦 Товарные остатки</div>
        <div class="compact-grid">
          <div class="compact-card"><div class="label">💰 Сумма закупки</div><div class="value">${totalCost.toFixed(2)} ₽</div></div>
          <div class="compact-card"><div class="label">💵 Сумма реализации</div><div class="value">${totalPrice.toFixed(2)} ₽</div></div>
          <div class="compact-card"><div class="label">📈 Коэффициент</div><div class="value">⨯${coefficient}</div></div>
        </div>
      </div>
      
      <!-- ЧЕТВЕРТЫЙ БЛОК: Выезды инженеров -->
      <div class="section">
        <div class="section-title">🔧 Выезды инженеров</div>
        <div class="total-card"><div class="label">💰 Общая сумма выездов</div><div class="value">${totalJobsSum.toFixed(2)} ₽</div></div>
      </div>
      
      <!-- ПЯТЫЙ БЛОК: Распределение актива -->
      <div class="section">
        <div class="section-title">💎 Распределение общего актива (с учетом товаров)</div>
        <div class="info-grid">
          <div class="info-card"><h4>👤 Андрей (50%)</h4><div class="value">${halfCalculatedAsset.toFixed(2)} ₽</div></div>
          <div class="info-card"><h4>👤 Юрий (50%)</h4><div class="value">${halfCalculatedAsset.toFixed(2)} ₽</div></div>
        </div>
      </div>
      
      <!-- ШЕСТОЙ БЛОК: Выплаченные дивиденды -->
      <div class="section">
        <div class="section-title">🎯 Выплаченные дивиденды</div>
        <div class="info-grid">
          <div class="info-card"><h4>👤 Андрей</h4><div class="value">${(andreyDividends || 0).toFixed(2)} ₽</div></div>
          <div class="info-card"><h4>👤 Юрий</h4><div class="value">${(yuriyDividends || 0).toFixed(2)} ₽</div></div>
        </div>
      </div>
      
      <!-- СЕДЬМОЙ БЛОК: История операций (С КОММЕНТАРИЯМИ) -->
      <div class="section">
        <div class="section-title">📜 История операций</div>
        <table>
          <thead>
            <tr><th>Дата</th><th>Операция</th><th>Сумма</th><th>Комментарий</th><th>Статус</th></tr>
          </thead>
          <tbody>
            ${Array.isArray(history) && history.slice(0, 20).map(item => `
              <tr>
                <td style="white-space: nowrap;">${escapeHtml(new Date(item.created_at).toLocaleString())}</td>
                <td>${escapeHtml(item.description)}</td>
                <td>${(Number(item.amount) || 0).toFixed(2)} ₽</td>
                <td style="font-style: italic; color: #666;">${escapeHtml(item.comment || '—')}</td>
                <td>${item.cancelled ? '❌ Отменена' : '✅ Активна'}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      </div>
      
      <div class="footer">
        <p>© ${new Date().getFullYear()} ТОТОСЕРВИС</p>
        <p>Отчет сгенерирован автоматически</p>
      </div>
      
      <div class="no-print" style="text-align: center; margin-top: 20px;">
        <button onclick="window.print()" style="padding: 8px 16px; background: #007bff; color: white; border: none; border-radius: 5px; cursor: pointer; font-size: 14px;">🖨️ Печать / Сохранить как PDF</button>
      </div>
    </body>
    </html>`;
    
    printWindow.document.write(reportHTML);
    printWindow.document.close();
  };
  
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '10px' }}>
        <h2>📊 Рентабельность</h2>
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
          <button 
            style={{ ...styles.dangerButton, background: '#ffc107', color: '#333' }}
            onClick={undoLastOperation}
            disabled={loading}
          >
            ↩️ Отменить последнюю операцию
          </button>
          <button 
            style={{ ...styles.button, background: '#17a2b8' }}
            onClick={generatePDF}
            disabled={loading}
          >
            📄 Полный отчет
          </button>
        </div>
      </div>
      
      {/* Поле АКТИВ с учетом товаров */}
      <div style={{
        background: calculatedTotalAsset >= 0 ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
        color: 'white',
        padding: '20px',
        borderRadius: '12px',
        marginBottom: '30px',
        textAlign: 'center'
      }}>
        <div style={{ fontSize: '14px', opacity: 0.9 }}>ОБЩИЙ АКТИВ (с учетом товаров на складе)</div>
        <div style={{ fontSize: '32px', fontWeight: 'bold' }}>{calculatedTotalAsset.toFixed(2)} ₽</div>
        {calculatedTotalAsset < 0 && (
          <div style={{ fontSize: '12px', marginTop: '5px', opacity: 0.8 }}>
            ⚠️ Превышение суммы товаров над вливаниями
          </div>
        )}
      </div>
      
      {/* ИНФОРМАЦИОННОЕ ТАБЛО */}
      <div style={{
        background: '#f8f9fa',
        borderRadius: '12px',
        padding: '20px',
        marginBottom: '20px',
        border: '1px solid #dee2e6'
      }}>
        <h3 style={{ margin: '0 0 15px 0', textAlign: 'center', color: '#007bff' }}>📊 Сводная информация</h3>
        
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: '15px',
          marginBottom: '20px',
          flexWrap: 'wrap'
        }}>
          <div style={{ flex: 1, background: '#fff', padding: '12px', borderRadius: '8px', textAlign: 'center' }}>
            <div style={{ fontSize: '12px', color: '#666' }}>👤 Андрей - Влил</div>
            <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#17a2b8' }}>{(usersData.andrey?.invested || 0).toFixed(2)} ₽</div>
          </div>
          <div style={{ flex: 1, background: '#fff', padding: '12px', borderRadius: '8px', textAlign: 'center' }}>
            <div style={{ fontSize: '12px', color: '#666' }}>👤 Юрий - Влил</div>
            <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#17a2b8' }}>{(usersData.yuriy?.invested || 0).toFixed(2)} ₽</div>
          </div>
        </div>
        
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
          marginBottom: '20px'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid #dee2e6' }}>
            <span>💰 Сумма товаров на остатках (закупка):</span>
            <strong style={{ color: '#dc3545' }}>- {totalCost.toFixed(2)} ₽</strong>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid #dee2e6' }}>
            <span>💵 Сумма товаров на остатках (реализация):</span>
            <strong>{totalPrice.toFixed(2)} ₽</strong>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid #dee2e6' }}>
            <span>📈 Общий коэффициент рентабельности:</span>
            <strong style={{ color: coefficient >= 1 ? '#28a745' : '#dc3545' }}>⨯{coefficient}</strong>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid #dee2e6' }}>
            <span>🔧 Общая сумма выездов инженеров:</span>
            <strong style={{ color: '#007bff' }}>{totalJobsSum.toFixed(2)} ₽</strong>
          </div>
        </div>
        
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: '15px',
          marginBottom: '20px',
          flexWrap: 'wrap'
        }}>
          <div style={{ flex: 1, background: '#fff', padding: '12px', borderRadius: '8px', textAlign: 'center', border: `1px solid ${halfCalculatedAsset >= 0 ? '#28a745' : '#dc3545'}` }}>
            <div style={{ fontSize: '12px', color: '#666' }}>👤 Андрей - Доля актива (50%)</div>
            <div style={{ fontSize: '20px', fontWeight: 'bold', color: halfCalculatedAsset >= 0 ? '#28a745' : '#dc3545' }}>
              {halfCalculatedAsset.toFixed(2)} ₽
            </div>
          </div>
          <div style={{ flex: 1, background: '#fff', padding: '12px', borderRadius: '8px', textAlign: 'center', border: `1px solid ${halfCalculatedAsset >= 0 ? '#28a745' : '#dc3545'}` }}>
            <div style={{ fontSize: '12px', color: '#666' }}>👤 Юрий - Доля актива (50%)</div>
            <div style={{ fontSize: '20px', fontWeight: 'bold', color: halfCalculatedAsset >= 0 ? '#28a745' : '#dc3545' }}>
              {halfCalculatedAsset.toFixed(2)} ₽
            </div>
          </div>
        </div>
        
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: '15px',
          flexWrap: 'wrap'
        }}>
          <div style={{ flex: 1, background: '#fff', padding: '12px', borderRadius: '8px', textAlign: 'center' }}>
            <div style={{ fontSize: '12px', color: '#666' }}>👤 Андрей - Выплаченные дивиденды</div>
            <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#28a745' }}>
              {(andreyDividends || 0).toFixed(2)} ₽
            </div>
          </div>
          <div style={{ flex: 1, background: '#fff', padding: '12px', borderRadius: '8px', textAlign: 'center' }}>
            <div style={{ fontSize: '12px', color: '#666' }}>👤 Юрий - Выплаченные дивиденды</div>
            <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#28a745' }}>
              {(yuriyDividends || 0).toFixed(2)} ₽
            </div>
          </div>
        </div>
      </div>

      {/* ФОРМА ВВОДА ОПЕРАЦИЙ (С КОММЕНТАРИЕМ) */}
      <div style={{ ...styles.form, marginTop: '30px' }}>
        <h3 style={{ margin: '0 0 10px 0' }}>✏️ Ввод операции</h3>
        
        <form onSubmit={handleSubmit}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill, minmax(200px, 1fr))',
            gap: '15px'
          }}>
            <select
              style={styles.selectInput}
              value={form.user}
              onChange={(e) => setForm({...form, user: e.target.value})}
            >
              <option value="andrey">Андрей</option>
              <option value="yuriy">Юрий</option>
            </select>
            
            <input
              style={styles.input}
              type="number"
              step="0.01"
              placeholder="Сумма"
              value={form.amount}
              onChange={(e) => setForm({...form, amount: e.target.value})}
              required
            />
            
            <select
              style={styles.selectInput}
              value={form.type}
              onChange={(e) => setForm({...form, type: e.target.value})}
            >
              <option value="prihod">💰 Приход</option>
              <option value="vlivaniya">💵 Вливания (50/50)</option>
              <option value="vernul">🔄 Вернул (из вливаний)</option>
              <option value="zakup">🛒 Закуп</option>
              <option value="dolg">📝 Долг</option>
              <option value="dividendsOne">🎯 Дивиденды одному</option>
              <option value="dividendsAll">👥 Дивиденды всем</option>
            </select>
            
            {/* НОВОЕ ПОЛЕ ДЛЯ КОММЕНТАРИЯ */}
            <input
              style={styles.input}
              type="text"
              placeholder="📝 Комментарий"
              value={form.comment}
              onChange={(e) => setForm({...form, comment: e.target.value})}
            />
            
            <button
              type="button"
              onClick={() => document.getElementById('receiptInput').click()}
              style={{
                background: hasFile ? '#28a745' : '#dc3545',
                color: 'white',
                border: 'none',
                padding: '12px',
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: 'bold',
                fontSize: '16px',
                minWidth: '80px',
                minHeight: '48px'
              }}
            >
              {hasFile ? '✅ ЧЕК' : '📝 ЧЕК обязательно'}
            </button>
            <input
              id="receiptInput"
              type="file"
              accept="image/*,application/pdf"
              onChange={handleFileChange}
              style={{ display: 'none' }}
            />
            
            <button
              type="submit"
              style={styles.squareButton}
              disabled={loading || uploading}
            >
              {loading || uploading ? '⏳' : '📤 Отпр'}
            </button>
          </div>
        </form>
      </div>
      
      {/* Окно истории (С КОММЕНТАРИЯМИ) */}
      <div style={{ 
        ...styles.historyWindow,
        backgroundColor: '#311d270b',
        border: '2px solid #210c02a9',
        borderRadius: '12px'
      }}>
        <h3 style={{ marginTop: 0, marginBottom: '15px' }}>📜 История операций</h3>
        {history.length === 0 ? (
          <div style={{ textAlign: 'center', color: '#6c757d', padding: '40px'}}>
            Пока нет операций
          </div>
        ) : (
          history.map(item => (
            <div 
              key={item.id} 
              style={{
                ...styles.historyItem,
                background: item.cancelled ? '#fefdfc' : 'transparent',
                opacity: item.cancelled ? 0.7 : 1,
                borderLeft: item.cancelled ? '3px solid #dc3545' : 'none'
              }}
            >
              <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '5px' }}>
                  <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
                    {new Date(item.created_at).toLocaleString()}
                  </span>
                  <span style={{ textDecoration: item.cancelled ? 'line-through' : 'none' }}>
                    {item.description}
                  </span>
                  {item.receipt_file && !item.cancelled && (
                    <a 
                      href={`${API_URL}/uploads/${item.receipt_file}`} 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      style={{ 
                        color: '#007bff',
                        textDecoration: 'none',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '4px'
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        window.open(`${API_URL}/uploads/${item.receipt_file}`, '_blank', 'noopener,noreferrer');
                      }}
                    >
                      📎 Чек
                    </a>
                  )}
                  {item.cancelled && (
                    <span style={{ color: '#dc3545', fontWeight: 'bold' }}>❌ ОТМЕНЕНА</span>
                  )}
                </div>
                {/* ПОКАЗЫВАЕМ КОММЕНТАРИЙ */}
                {item.comment && !item.cancelled && (
                  <div style={{ 
                    fontSize: '12px', 
                    color: '#666', 
                    fontStyle: 'italic',
                    marginTop: '4px',
                    paddingLeft: '10px',
                    borderLeft: '2px solid #007bff'
                  }}>
                    💬 {item.comment}
                  </div>
                )}
              </div>
            </div>
          ))
        )}
      </div>
      
      {/* Карточки пользователей с учетом товаров */}
      <div style={{
        display: 'flex',
        gap: '20px',
        marginBottom: '30px',
        flexWrap: 'wrap',
        flexDirection: isMobile ? 'column' : 'row'
      }}>
        {/* Андрей */}
        <div style={{
          flex: isMobile ? '1' : '1',
          minWidth: isMobile ? 'auto' : '250px',
          background: '#dbd4d394',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          borderLeft: `4px solid ${adjustedAndreyProfitability >= 0 ? '#28a745' : '#dc3545'}`
        }}>
          <h3 style={{ margin: '0 0 15px 0', textAlign: 'center' }}>👤 {usersData.andrey?.name || 'Андрей'}</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <div style={{ 
              background: adjustedAndreyProfitability >= 0 ? '#28a745' : '#dc3545',
              color: 'white',
              padding: '15px',
              borderRadius: '8px',
              textAlign: 'center'
            }}>
              <div style={{ fontSize: '12px', opacity: 0.9 }}>Рентабельность (с учетом товаров)</div>
              <div style={{ fontSize: '24px', fontWeight: 'bold' }}>
                {adjustedAndreyProfitability.toFixed(2)} ₽
              </div>
            </div>
            <div style={{ 
              background: '#17a2b8',
              color: 'white',
              padding: '12px',
              borderRadius: '8px',
              textAlign: 'center'
            }}>
              <div style={{ fontSize: '12px', opacity: 0.9 }}>Влил</div>
              <div style={{ fontSize: '20px', fontWeight: 'bold' }}>{(usersData.andrey?.invested || 0).toFixed(2)} ₽</div>
            </div>
            <div style={{ 
              background: (usersData.andrey?.debt || 0) > 0 ? '#dc3545' : ((usersData.andrey?.debt || 0) < 0 ? '#28a745' : '#6c757d'),
              color: 'white',
              padding: '8px 12px',
              borderRadius: '8px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: isMobile ? 'auto' : '15%',
              minWidth: '120px'
            }}>
              <span style={{ fontSize: '13px' }}>
                {(usersData.andrey?.debt || 0) > 0 ? 'Должен' : ((usersData.andrey?.debt || 0) < 0 ? 'Одолжил' : 'Долг')}
              </span>
              <span style={{ fontSize: '16px', fontWeight: 'bold' }}>
                {(usersData.andrey?.debt || 0) !== 0 ? Math.abs(usersData.andrey?.debt || 0).toFixed(2) + '₽' : '—'}
              </span>
            </div>
          </div>
        </div>
        
        {/* Юрий */}
        <div style={{
          flex: isMobile ? '1' : '1',
          minWidth: isMobile ? 'auto' : '250px',
          background: '#dbd4d394',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          borderLeft: `4px solid ${adjustedYuriyProfitability >= 0 ? '#28a745' : '#dc3545'}`
        }}>
          <h3 style={{ margin: '0 0 15px 0', textAlign: 'center' }}>👤 {usersData.yuriy?.name || 'Юрий'}</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <div style={{ 
              background: adjustedYuriyProfitability >= 0 ? '#28a745' : '#dc3545',
              color: 'white',
              padding: '15px',
              borderRadius: '8px',
              textAlign: 'center'
            }}>
              <div style={{ fontSize: '12px', opacity: 0.9 }}>Рентабельность (с учетом товаров)</div>
              <div style={{ fontSize: '24px', fontWeight: 'bold' }}>
                {adjustedYuriyProfitability.toFixed(2)} ₽
              </div>
            </div>
            <div style={{ 
              background: '#17a2b8',
              color: 'white',
              padding: '12px',
              borderRadius: '8px',
              textAlign: 'center'
            }}>
              <div style={{ fontSize: '12px', opacity: 0.9 }}>Влил</div>
              <div style={{ fontSize: '20px', fontWeight: 'bold' }}>{(usersData.yuriy?.invested || 0).toFixed(2)} ₽</div>
            </div>
            <div style={{ 
              background: (usersData.yuriy?.debt || 0) > 0 ? '#dc3545' : ((usersData.yuriy?.debt || 0) < 0 ? '#28a745' : '#6c757d'),
              color: 'white',
              padding: '8px 12px',
              borderRadius: '8px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: isMobile ? 'auto' : '15%',
              minWidth: '120px'
            }}>
              <span style={{ fontSize: '13px' }}>
                {(usersData.yuriy?.debt || 0) > 0 ? 'Должен' : ((usersData.yuriy?.debt || 0) < 0 ? 'Одолжил' : 'Долг')}
              </span>
              <span style={{ fontSize: '16px', fontWeight: 'bold' }}>
                {(usersData.yuriy?.debt || 0) !== 0 ? Math.abs(usersData.yuriy?.debt || 0).toFixed(2) + '₽' : '—'}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
// --- ГЛАВНЫЙ КОМПОНЕНТ ---
function App() {
  const [activeTab, setActiveTab] = useState('inventory');
  const [items, setItems] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadItems = async () => {
    try {
      const response = await fetch(`${API_URL}/items.php`);
      const data = await response.json();
      setItems(data);
      return data;
    } catch (error) {
      console.error('Ошибка загрузки товаров:', error);
      return [];
    }
  };

  const loadJobs = async () => {
    try {
      const response = await fetch(`${API_URL}/jobs.php`);
      const data = await response.json();
      setJobs(data);
      return data;
    } catch (error) {
      console.error('Ошибка загрузки выездов:', error);
      return [];
    }
  };

  useEffect(() => {
    const init = async () => {
      setLoading(true);
      await Promise.all([loadItems(), loadJobs()]);
      setLoading(false);
    };
    init();
  }, []);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', marginTop: '100px' }}>
        <h2>🔄 Загрузка данных с сервера...</h2>
      </div>
    );
  }

  return (
    <PasswordGuard>
      <MobileStyles />
      <div style={styles.container}>
        <div style={styles.header}>
          <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
            <button style={styles.tabButton(activeTab === 'inventory')} onClick={() => setActiveTab('inventory')}>📦 </button>
            <button style={styles.tabButton(activeTab === 'jobs')} onClick={() => setActiveTab('jobs')}>🔧</button>
            <button style={styles.tabButton(activeTab === 'profitability')} onClick={() => setActiveTab('profitability')}>📊 </button>
          </div>
        </div>
        
        {activeTab === 'inventory' && (
          <InventoryPage 
            items={items} 
            setItems={setItems}
            onLoadItems={loadItems}
          />
        )}
        {activeTab === 'jobs' && (
          <JobsPage 
            items={items}
            setItems={setItems}
            jobs={jobs}
            setJobs={setJobs}
            onLoadJobs={loadJobs}
            onLoadItems={loadItems}
          />
        )}
        {activeTab === 'profitability' && (
          <ProfitabilityGuard>
            <ProfitabilityPage />
          </ProfitabilityGuard>
        )}
      </div>
    </PasswordGuard>
  );
}

export default App;